import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Button as BButton} from 'reactstrap';
import styled from 'styled-components';
import {ThemeContext} from '../../apiContexts';

const BButtonStyled = styled(BButton)`

     margin: 10px;
     border-radius: 12px;
     min-width: 119px;
     min-height: 45px;
     color: white;
     font-size: 16px;
     
     &.btn-sm {
         border-radius: 7px;
         min-width: auto;
         min-height: auto;
         font-size: 13px;
         padding: 5px 15px 5px 15px;
     }

     &.btn.btn-success:not(:hover) { 
          background-color: #009018;
          box-shadow: 0px 3px 6px #00000029;
     }
     
     &.btn.btn-warning:not(:hover) { 
          background-color: #F08100;
          box-shadow: 0px 3px 6px #00000029;
     }
     
     &.outline.btn.btn-warning:not(:hover) { 
          color: #F08100;
          border-color: #F08100;
          background-color: white;
     }
     
     &.outline.btn.btn-danger:not(:hover) { 
          color: #BF2A24;
          border-color: #BF2A24;
          background-color: white;
     }
     
     &.outline.btn.btn-danger:hover { 
          color: white;
          border-color: #BF2A24;
          background-color: #BF2A24; !important
     }
     
     &.outline.btn.btn-theme:not(:hover) { 
          color: ${(props) => props.theme};
          border-color: ${(props) => props.theme};
          background-color: white;
     }
     
     &.outline.btn.btn-theme:hover { 
          color: white;
          border-color: ${(props) => props.theme};
          background-color: ${(props) => props.theme} !important;
     }

     /* index.sass paints every .btn-theme with currentColor on hover/active (meant for outline
        buttons); on a solid button that is the white text, so the fill is restated here. */
     &.solid.btn.btn-theme,
     &.solid.btn.btn-theme:hover,
     &.solid.btn.btn-theme:active,
     &.solid.btn.btn-theme:focus {
          color: white;
          border-color: ${(props) => props.theme} !important;
          background-color: ${(props) => props.theme} !important;
     }

     &.solid.btn.btn-theme:hover:not(:disabled),
     &.solid.btn.btn-theme:active:not(:disabled) {
          filter: brightness(0.9);
     }

     /* Bootstrap's .btn-secondary turns the text white on :active/:focus; a neutral button keeps
        its dark text on a light fill in every state. */
     &.neutral.btn,
     &.neutral.btn:focus {
          color: #3d4a5c !important;
          border-color: #c9d3df !important;
          background-color: white !important;
     }

     &.neutral.btn:hover:not(:disabled),
     &.neutral.btn:active:not(:disabled) {
          color: #3d4a5c !important;
          border-color: #c9d3df !important;
          background-color: #f1f5f9 !important;
     }
        
`;

const Button = (props) => {
    const theme = useContext(ThemeContext);
    const {
        disabled,
        onClick,
        type,
        color,
        size,
        className,
        children,
        ...rest
    } = props;

    return (<React.Fragment>
        <BButtonStyled
            disabled={disabled ? disabled : false}
            onClick={type === 'submit' ? null : onClick}
            type={type || 'button'}
            color={color}
            size={size}
            theme={theme}
            className={`${className}`}
            {...rest}>
            {children}
        </BButtonStyled>
    </React.Fragment>);
};

Button.propTypes = {
    'label': PropTypes.string,
    'type': PropTypes.string,
    'icon': PropTypes.string,
    'iconRight': PropTypes.string,
    'onClick': PropTypes.func,
    'className': PropTypes.string,
    'color': PropTypes.string,
    'size': PropTypes.string,
    'disabled': PropTypes.bool,
    'title': PropTypes.string,
    'aria-label': PropTypes.string,
    'children': PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.node,
          PropTypes.element,
    ]),
};

export default Button;
